import React from 'react'
import '../Poster/Poster.css'
import { BiSolidPhoneCall } from "react-icons/bi";
const Poster = () => {
  const handleCallNow = () => {
    window.location.href = 'tel:+919555768358';
};
    return (
      <div className="poster">
        <div className="overlay">
          <div className="content">
            <p className="tagline">A Gateway to Your Dream Home</p>
            <h1 className="title">Luxury Pan Oasis </h1>
           
            
            <div className="row-content">
            <button className="contact-button" onClick={handleCallNow}><BiSolidPhoneCall /> +91 9555768358</button>
              <h1 className="extra-title">3 BHK  Flats</h1>
              <p className="extra-description"> Experience luxury living with spacious 3 BHK flats designed for your comfort and lifestyle. 
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Poster;